import { loggerCan } from '@/data/utils/loggerUtil';
import { HttpClient, RequestParams } from './http-client';
import { logger } from '@/logging/logger';

export interface CouponStatusResponse {
	response?: {
		longDescription?: string;
		shortDescription?: string;
		languageId?: string;
		promotionId?: string;
	};
}

export class CouponStatus<SecurityDataType = unknown> {
	http: HttpClient<SecurityDataType>;
	traceDetails: string | undefined;

	constructor(http: HttpClient<SecurityDataType>) {
		this.http = http;
		this.traceDetails = process.env.TRACE_DETAILS?.trim();
	}

	findCouponStatus = (storeId: string, promotionId: string, params: RequestParams = {}) => {
		const { _requestId: requestId } = params as any;
		delete (params as any)._requestId;

		if (
			loggerCan('trace') &&
			(!this.traceDetails || this.traceDetails.includes('findCouponStatus'))
		) {
			const paramsLogger = logger.child({
				params,
				query: {},
				body: {},
				methodName: 'findCouponStatus',
				requestId,
			});
			paramsLogger.trace('API request parameters');
		}

		return this.http.request<CouponStatusResponse, void>({
			path: `/store/${storeId}/CouponStatus/${promotionId}`,
			method: 'GET',
			secure: true,
			format: params.format ?? 'json',
			storeId,
			...params,
		});
	};
}
